// 正式
module.exports = {
  env: 'production',
  title: 'cocorobo', // 代理端-生产
  baseUrl: 'https://www.xxx.com/', // 正式项目地址
  baseApi: 'https://pbl.cocorobo.cn/api/pbl/', // 正式api请求地址
  aiBotUrl: 'https://support-assistant.cocorobo.cn', // AI助手正式环境地址 (请修改为实际地址)
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://imgs.solui.cn'
}
